module.exports = __webpack_public_path__ + "img/couples_01_V.db3196d8.webp";